import { createFileRoute } from "@tanstack/react-router"
import CompanySettingsPage from "../../../components/Settings/CompanySettingsPage"

export const Route = createFileRoute("/_layout/company-settings/")({
  component: CompanySettingsPage,
})
